var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCustomsAlert = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98085 0.606318C7.57671 -0.202107 6.42328 -0.202106 6.01915 0.606319L0.117188 12.4126C-0.247384 13.1419 0.282827 14 1.09803 14H12.902C13.7172 14 14.2474 13.1419 13.8828 12.4126L7.98085 0.606318ZM6 5C6 4.44772 6.44772 4 7 4C7.55228 4 8 4.44772 8 5V8C8 8.55228 7.55228 9 7 9C6.44772 9 6 8.55228 6 8V5ZM6 11C6 10.4477 6.44772 10 7 10C7.55228 10 8 10.4477 8 11C8 11.5523 7.55228 12 7 12C6.44772 12 6 11.5523 6 11Z",
    fill: "#856404"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCustomsAlert, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/customsAlert.4227b3e5.svg";
export { ForwardRef as ReactComponent };